import React from 'react';
import Link from 'next/link';
import round from 'lodash/round';
import GeneralChart from '@/components/seo/GeneralChart';
import { JobTitleContext } from '@/context/create-context';

const RecruitmentCity = (props: {
  id: string;
  cityData: Record<string, any>;
}) => {
  const { cityData, id } = props;

  const {
    jobTitle: {
      id: jobTitleId,
      job_open_details: { city_stats },
    },
    isJobTitleCity,
  } = React.useContext(JobTitleContext);
  const cityStatsRank = city_stats?.by_current_count;

  if (!cityStatsRank || !cityStatsRank.length) return null;

  return (
    <GeneralChart title="不同城市的需求分析" tip={cityData['tip']} id={id}>
      <p className="mb-2">
        {cityData['总结']?.[isJobTitleCity ? '城市趋势' : '全国趋势'] || ''}
      </p>
      <ul className="!ml-0 my-6 list-none flex flex-col items-center gap-2">
        <table className="w-full text-left">
          <tbody>
            {cityStatsRank.map(
              ({ name, rank, pinyin, ratio, count, current_city }, index) => (
                <tr key={pinyin + index}>
                  <td className="text-right py-1">
                    {`#${rank || ''} `}
                    <Link
                      href={`/${pinyin}/${jobTitleId}/`}
                      className="hover:underline"
                    >
                      {name.replace('市', '')}
                    </Link>
                  </td>
                  <td className="min-w-80 px-4">
                    <div className="h-2 rounded-full bg-web-grey-50 overflow-hidden">
                      <div
                        className="h-full rounded-full bg-gradient-to-r from-web-aqua-600 to-web-blue-600"
                        style={{ width: `${round(ratio * 100, 1)}%` }}
                      />
                    </div>
                  </td>
                  <td className="text-web-grey-600">
                    <span className="mr-4">{round(ratio * 100, 1)}%</span>
                    {`${count} 个岗位`}
                  </td>
                </tr>
              ),
            )}
          </tbody>
        </table>
      </ul>
      <p className="font-semibold mb-2">市场解读</p>
      <ul className="list-inside !ml-2 mb-2">
        {(cityData?.['市场解读'] || []).map((item: string, index: number) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </GeneralChart>
  );
};

export default RecruitmentCity;
